import { render, staticRenderFns } from "./Phototype.vue?vue&type=template&id=738216ad"
import script from "./Phototype.vue?vue&type=script&lang=js"
export * from "./Phototype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports